import {
  CustomFormTemplatePageBackgroundFilePayload,
  FileEntity
} from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  formTemplateId: number;
  payload: CustomFormTemplatePageBackgroundFilePayload
}

export const updateCustomFormTemplatePageBackgroundRequest = ({
                                                                token,
                                                                formTemplateId,
                                                                payload: {
                                                                  pageUuid,
                                                                  fileEntity,
                                                                  file,
                                                                }
                                                              }: RequestParams): Promise<FileEntity | null> => {
  const formData = new FormData();

  formData.append('page_uuid', pageUuid);
  if (fileEntity) {
    formData.append('file_dto', JSON.stringify(fileEntity));
  }
  if (file) {
    formData.append('upload_file', file);
  }

  return ApiServiceInstance.makeRequest<FileEntity | null>(`/custom-form-template/${ formTemplateId }/update-page-background`, {
    method: 'POST',
    token,
    body: formData,
  });
};